export const inIframe = (): boolean => {
  try {
    return window.self !== window.top;
  } catch {
    return true;
  }
};

export function getUrlWithProtocol(urlStr: string): string | null {
  // Falsy values like null, are returned as null.
  if (!urlStr?.trim?.()) return null;

  // Remove protocol if exists
  urlStr = urlStr.replace(/(^\w+:|^)\/\//, '').trim();

  // Check the allowed urls only
  const allowedUrls = ['pleased.com', 'pleased2.com', 'localhost'];
  if (!allowedUrls.some((domain) => urlStr.indexOf(domain) !== -1)) {
    return null;
  }

  // Ensure single trailing slash
  urlStr = urlStr.replace(/\/+$/, '');

  // Join protocol and url
  const resultUrl = 'https:' + '//' + urlStr + '/';

  return resultUrl;
}
